import type { Session } from 'api';
import { useTranslation } from 'i18n';
import { Link } from 'react-router-dom';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, Typography } from 'ui';
import { ExpandMore } from 'ui/icons';

import { EvidenceSampleSessionDetails } from '../EvidenceSampleSessionDetails/EvidenceSampleSessionDetails';
import { EvidenceSessionSummary } from '../EvidenceSessionSummary/EvidenceSessionSummary';

export const EvidenceSampleSession = ({
  session,
  defaultExpanded = false,
  siteMaterialId,
}: {
  defaultExpanded?: boolean;
  session: Session;
  siteMaterialId: number;
}) => {
  const { t } = useTranslation('features');
  const { date, uploaded_by, parent_id, origin } = session;

  return (
    <Accordion defaultExpanded={defaultExpanded} variant="outlined">
      <AccordionSummary expandIcon={<ExpandMore />}>
        <EvidenceSessionSummary date={date} uploadedBy={uploaded_by} origin={origin} />
      </AccordionSummary>
      <AccordionDetails>
        {parent_id ? (
          <EvidenceSampleSessionDetails parentId={parent_id} siteMaterialId={siteMaterialId} />
        ) : (
          <Typography>{t('backlog.common.noData')}</Typography>
        )}
      </AccordionDetails>
      <AccordionActions>
        <Button component={Link} to={`/quality/${siteMaterialId}/sample/${parent_id}/edit`}>
          {t('backlog.evidence.common.editSample')}
        </Button>
      </AccordionActions>
    </Accordion>
  );
};
